import { useId } from "react";
import { AioComment } from "../additional/aioComment";
import styles from "../aic.module.css";
import {
  AitLocationBodyCell,
  AitLocationBodyRowGroup,
  AitLocationHeader,
  AitLocationHeaderCell,
  AitLocationTable,
  UPDATE_COMMENTS,
} from "./functions/interface";
import { trGetPositionFromLocation } from "./functions/trGetPositionFromLocation";
import { useTableContext } from "./TableContextProvider";

interface AitCommentRowProps {
  location:
    | AitLocationTable
    | AitLocationHeader
    | AitLocationHeaderCell
    | AitLocationBodyRowGroup
    | AitLocationBodyCell;
}

/**
 * Render a comment editor row for a given table location.
 *
 * @param props - Component props
 * @param props.location - The table location for the comment editor
 */
export const AitCommentRow = ({ location }: AitCommentRowProps) => {
  const id = useId();
  const { state, dispatch } = useTableContext();
  const locationPoint = trGetPositionFromLocation(state, location, true);
  const thisComment =
    locationPoint.data && "comments" in locationPoint.data ? locationPoint.data.comments : "";
  const isLocationRepeat = "isRepeat" in location ? location.isRepeat : false;
  return !state ? (
    <></>
  ) : (
    <div className={styles.aiwBodyRow}>
      <AioComment
        id={`${state.id}-${location.position}-comment-${id}`}
        label={"Notes"}
        value={thisComment}
        editable={state.editable && !isLocationRepeat}
        setValue={(ret) => {
          dispatch({
            operation: UPDATE_COMMENTS,
            location: location,
            comment: ret,
          });
        }}
      />
    </div>
  );
};

AitCommentRow.displayName = "AitCommentRow";
